import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=abcd6bfa&scoped=true&lang=pug"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcd6bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abcd6bfa')) {
      api.createRecord('abcd6bfa', component.options)
    } else {
      api.reload('abcd6bfa', component.options)
    }
    module.hot.accept("./ModalConfirm.vue?vue&type=template&id=abcd6bfa&scoped=true&lang=pug", function () {
      api.rerender('abcd6bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalConfirm.vue"
export default component.exports